import type { ScanResult } from '@blackfisk/domain/barcode/types.js'

import { parseScan } from '@blackfisk/domain/barcode/parser.js'
import { computed, onMounted, onUnmounted, ref } from 'vue'

const scans = ref<ScanResult[]>([])
const latestScan = computed<ScanResult | undefined>(() => scans.value?.[scans.value.length - 1])
const scanReadValue = ref('')
let scanInputTimeoutId: NodeJS.Timeout | null = null

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useScanner = () => {
  const onScanReadComplete = (): void => {
    scanReadValue.value = ''
  }
  const onKeyPress = (event: KeyboardEvent): void => {
    const key = event.key
    const target = event.target as HTMLElement
    if (
      target === null ||
      ['input', 'select', 'textarea'].includes((target?.nodeName ?? '').toLowerCase())
    ) {
      return
    }
    if (scanInputTimeoutId) {
      clearTimeout(scanInputTimeoutId)
      scanInputTimeoutId = null
    }
    if (!scanInputTimeoutId) {
      scanInputTimeoutId = setTimeout(onScanReadComplete, 250)
    }
    if (key === 'Enter' || key === 'Tab') {
      const parsedScan = parseScan(scanReadValue.value)
      scans.value.push(parsedScan)
      event.preventDefault()
    } else if (!['Escape', 'Shift'].includes(key)) {
      scanReadValue.value += key
    }
  }
  const registerScanner = (): void => {
    onMounted(() => {
      window.removeEventListener('keydown', onKeyPress)
      window.addEventListener('keydown', onKeyPress)
    })
    onUnmounted(() => {
      window.removeEventListener('keydown', onKeyPress)
    })
  }
  return {
    registerScanner,
    latestScan,
    scans,
  }
}
